import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconMinus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 2,
	viewBox: "0 0 18 2",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 0H17C17.5523 0 18 0.447715 18 1C18 1.55228 17.5523 2 17 2H1C0.447716 2 0 1.55228 0 1C0 0.447715 0.447716 0 1 0Z",
		fill: "white"
	})
});
export default SvgIconMinus;
